import { createStore, combineReducers, applyMiddleware} from 'redux'
import {thunk} from 'redux-thunk'
import { composeWithDevTools} from '@redux-devtools/extension'
import {
    userLoginReducer,
    userRegisterReducer,
    userDetailsReducer,
    userUpdateProfileReducer,
    registerLicenseReducer, 
    submitExperienceReducer,
    getAllUsersReducer,
    getUserLocationReducer,
    getResetPasswordReducer,
    confirmRegistrationReducer,
    getOpenPCRCreateDialogReducer
} from './reducers/userReducers'

import { getAllCommentsReducer } from './reducers/commentReducers'
import { getApplyTemplateReducer, getCHARTReducer, getConciseReportReducer, getEncodeReducer, getLabReducer, getReclassifyReducer, getReportFeedbackReducer, getReportReducer, getSOAPReducer } from './reducers/encodeReducers'
import { getTemplateContentReducer, getTemplateUpdateReducer, getUserTemplatesReducer, getTemplateDeleteReducer, getTemplateCreateReducer } from './reducers/templateReducers'
import { getCreateReducer } from './reducers/createReducer'
import { getTestMergeReducer } from './reducers/testReducers'
import { feedbackCreateReducer, feedbackListReducer, feedbackContentReducer, callTypesReducer } from './reducers/feedbackReducers'
import { reportConfigGetReducer, reportConfigUpdateReducer } from './reducers/reportReducers'

const reducer = combineReducers({
    userLogin: userLoginReducer,
    userRegister: userRegisterReducer,
    userDetails: userDetailsReducer,
    userUpdateProfile: userUpdateProfileReducer,
    userResetPassword: getResetPasswordReducer,
    userConfirmRegistration: confirmRegistrationReducer,
    userLocation: getUserLocationReducer,
    users: getAllUsersReducer,
    registerLicense: registerLicenseReducer,
    submitExperience: submitExperienceReducer,
    comments: getAllCommentsReducer,
    encodeReducer: getEncodeReducer,
    reportReducer: getReportReducer,
    templateReducer: getApplyTemplateReducer,
    templateContentReducer: getTemplateContentReducer,
    conciseTextReducer: getConciseReportReducer,
    feedbackTextReducer: getReportFeedbackReducer,
    reclassifyReducer: getReclassifyReducer,
    templateCreateReducer: getTemplateCreateReducer,
    templateUpdateReducer: getTemplateUpdateReducer,
    templateDeleteReducer: getTemplateDeleteReducer,
    createReducer: getCreateReducer,
    labReducer: getLabReducer,
    openPCRCreateDialogReducer: getOpenPCRCreateDialogReducer,

    userTemplateReducer: getUserTemplatesReducer,

    testMergeReducer: getTestMergeReducer,

    feedbackCreateReducer: feedbackCreateReducer,
    feedbackListReducer: feedbackListReducer,
    feedbackContentReducer: feedbackContentReducer,
    callTypesReducer: callTypesReducer,

    reportConfigGet: reportConfigGetReducer,
    reportConfigUpdate: reportConfigUpdateReducer,
})

const userInfoFromStorage = window.localStorage.getItem('userInfo')
    ? JSON.parse(window.localStorage.getItem('userInfo'))
    : null;

const userLocationFromStorage = window.localStorage.getItem('userLocation')
    ? JSON.parse(window.localStorage.getItem('userLocation'))
    : null;

const initialState = {
    userLogin: { userInfo: userInfoFromStorage },
    userLocation: { userLocation: userLocationFromStorage },
}

const middleware = [thunk]

const store = createStore(reducer, initialState,
        composeWithDevTools(applyMiddleware(...middleware)))

export default store
